module.exports = __webpack_public_path__ + "img/logo_sslife@3x.b9fa2e06.png";